module.exports = __webpack_public_path__ + "static/media/A2_20.a0815178.png";